import { IncomingMessages } from "@mos-utils/acs";
import { useReducer } from "react";
import { useACSSubscription } from "./useAcsSubscription";

/**
 * @public
 */
export type UseAuthorizationStatusState =
  | "unknown"
  | "authorized"
  | "unauthorized"
  | "exit";

function statusReducer(
  state: UseAuthorizationStatusState,
  message: IncomingMessages | IncomingMessages[]
): UseAuthorizationStatusState {
  if (Array.isArray(message))
    return message.reduce((s, m) => statusReducer(s, m), state);
  if (message.type === "USER_UNAUTHORIZED") return "unauthorized";
  if (message.type === "USER_AUTHORIZED") return "authorized";
  if (message.type === "EXITING") return "exit";
  return state;
}

/**
 * @public
 */
export function useAuthorizationStatus(): UseAuthorizationStatusState {
  const [state, dispatch] = useReducer(statusReducer, "unknown");
  useACSSubscription(dispatch);
  return state;
}
